<template>
  <div
    class="course-home"
    v-loading="listLoading"
    element-loading-text="加载中..."
    element-loading-spinner="el-icon-loading"
  >
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <div class="nav-content">
        <div v-if="listError" class="list-error-banner">
          <el-alert type="error" show-icon :closable="false" title="分类列表加载失败，请稍后重试" />
          <div class="list-error-actions">
            <el-button type="primary" size="small" @click="getClassCourseList">重新加载</el-button>
          </div>
        </div>
        <div v-else-if="!listLoading && classCourseList.length === 0" class="nav-tabs nav-tabs--empty">
          <el-empty description="暂无课程分类，请稍后再试或联系管理员">
            <el-button type="primary" size="small" @click="getClassCourseList">刷新</el-button>
          </el-empty>
        </div>
        <div class="nav-tabs" v-else>
          <el-tabs v-model="activeTab" type="card">
            <el-tab-pane 
              v-for="(item) in classCourseList"
              :key="item.id"
              :label="item.name"
              :name="item.id"
            >
              <div class="tab-content">
                <!-- 仅首个分类 Tab 展示轮播；数据来自该分类 courseList 前 3 条 -->
                <div
                  v-if="isFirstClassification(item) && firstTabBannerSlides.length"
                  class="banner-section"
                >
                  <el-carousel height="300px" :interval="4000" type="card">
                    <el-carousel-item
                      v-for="course in firstTabBannerSlides"
                      :key="course.courseId"
                    >
                      <router-link
                        :to="{ name: 'coursedetail', params: { courseId: course.courseId } }"
                        class="banner-link"
                      >
                        <div class="banner-item">
                          <img :src="course.cover" :alt="course.name" @error="onCoverError">
                          <div class="banner-info">
                            <h3>{{ course.name }}</h3>
                            <p v-if="bannerDescription(course)">{{ bannerDescription(course) }}</p>
                          </div>
                        </div>
                      </router-link>
                    </el-carousel-item>
                  </el-carousel>
                </div>

                <!-- 视频分类区域 -->
                <div class="category-section">
                  <h2 class="section-title">{{ item.name }}</h2>
                  <el-empty
                    v-if="!item.courseList || item.courseList.length === 0"
                    description="该分类下暂无内容"
                    :image-size="80"
                  />
                  <template v-else>
                    <p v-if="item.courseList.length === 1" class="single-category-hint">本分类仅 1 个内容</p>
                    <div class="course-grid">
                    <div
                      v-for="(course, index) in item.courseList"
                      :key="course.courseId"
                      class="course-card"
                      v-show="index < 10"
                    >
                      <router-link
                        :to="{ name: 'coursedetail', params: { courseId: course.courseId } }"
                        class="course-link"
                      >
                        <div class="card-cover">
                          <img :src="course.cover" :alt="course.name" @error="onCoverError">
                          <!-- 播放量未返回时不展示数字，仅保留播放示意 -->
                          <div class="card-overlay">
                            <span class="play-hint" title="观看">
                              <i class="el-icon-video-play"></i>
                            </span>
                          </div>
                        </div>
                        <div class="card-info">
                          <h3 class="card-title">{{ course.name }}</h3>
                          <!-- 教师、时长等暂无可靠数据时先隐藏 -->
                          <!--
                          <div class="card-meta">
                            <span class="teacher">
                              <i class="el-icon-user"></i>
                              {{ course.teacher || '未知教师' }}
                            </span>
                            <span class="duration">
                              <i class="el-icon-time"></i>
                              {{ course.duration || '0分钟' }}
                            </span>
                          </div>
                          -->
                        </div>
                      </router-link>
                    </div>
                  </div>
                  </template>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: '',
      listLoading: true,
      listError: false,
      recommendCourseList: [],
      classCourseList: [],
    };
  },
  computed: {
    /** 首个分类下的课程，取前 3 条作为轮播 */
    firstTabBannerSlides() {
      const first = this.classCourseList[0];
      if (!first || !Array.isArray(first.courseList)) return [];
      return first.courseList.slice(0, 3);
    },
  },
  created() {
    this.getClassCourseList();
  },
  methods: {
    onCoverError(e) {
      e.target.src = require('@/assets/plant/cat3.png');
    },
    isFirstClassification(item) {
      if (!item || !this.classCourseList.length) return false;
      return String(item.id) === String(this.classCourseList[0].id);
    },
    bannerDescription(course) {
      if (!course || !course.description) return "";
      const s = String(course.description).trim();
      return s || "";
    },
    getClassCourseList() {
      this.listLoading = true;
      this.listError = false;
      this.$request
        .callApi("GET", this.$robotApi.getCourseByClassfication)
        .then((res) => {
          const raw = res && res.data;
          this.classCourseList = Array.isArray(raw) ? raw : [];
          if (this.classCourseList.length > 0) {
            this.activeTab = this.classCourseList[0].id;
          }
        })
        .catch(() => {
          this.listError = true;
          this.classCourseList = [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-home {
  min-height: 100vh;
  background: #f4f4f4;
}

.list-error-banner {
  padding: 16px 20px 0;
}

.list-error-actions {
  margin-top: 10px;
  padding: 0 8px 8px;
}

.nav-tabs--empty {
  padding: 48px 20px;
  display: flex;
  justify-content: center;
}

.single-category-hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: #909399;
}

.nav-bar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.nav-tabs {
  :deep(.el-tabs__nav-wrap::after) {
    display: none;
  }

  :deep(.el-tabs__item) {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #666;
    border: none;
    padding: 0 20px;
    transition: all 0.3s ease;

    &.is-active {
      color: #00a1d6;
      font-weight: 600;
    }

    &:hover {
      color: #00a1d6;
    }
  }

  :deep(.el-tabs__active-bar) {
    height: 3px;
    background: #00a1d6;
    border-radius: 3px;
  }
}

.tab-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.banner-section {
  margin-bottom: 30px;

  .banner-link {
    display: block;
    height: 100%;
    text-decoration: none;
    color: inherit;
    outline: none;
  }

  :deep(.el-carousel__item) {
    border-radius: 8px;
    overflow: hidden;
  }

  .banner-item {
    position: relative;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner-info {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px;
      background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
      color: #fff;

      h3 {
        margin: 0 0 8px;
        font-size: 24px;
        font-weight: 600;
      }

      p {
        margin: 0;
        font-size: 14px;
        opacity: 0.9;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
}

.category-section {
  .section-title {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px;
    font-weight: 600;
  }
}

.course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.course-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .course-link {
    text-decoration: none;
    color: inherit;
  }

  .card-cover {
    position: relative;
    padding-top: 56.25%; // 16:9 比例

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .card-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.3);
      opacity: 0;
      transition: opacity 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      .play-hint {
        color: #fff;
        font-size: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &:hover .card-overlay {
      opacity: 1;
    }
  }

  .card-info {
    padding: 12px;

    .card-title {
      margin: 0 0 8px;
      font-size: 14px;
      color: #333;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .card-meta {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 12px;
      color: #999;

      i {
        margin-right: 4px;
      }
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .course-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }

  .banner-section {
    :deep(.el-carousel__item) {
      height: 200px;
    }
  }
}
</style>